<template>
  <el-dialog title="修改" :modal-append-to-body="false" :show-close="true" :close-on-click-modal="false"
    :append-to-body="true" :visible.sync="visible" class="editbatch" width="100%">
    <div class="mod-config" style="height: 98%;">
      <div class="boxuser" style="height: 100%;">
        <!-- 模板一 -->
        <div class="userMuban">
          <el-form :model="dataForm" :rules="dataRule" ref="dataForm">
            <label style="float: left;line-height: 40px;padding-right: 10px;">模板名称</label>
            <el-input v-model="dataForm.formname" style="float: left;width: 200px;" placeholder="模板名称"
              clearable></el-input>
            <el-table :data="dataForm.deviceList" stripe style="width: 100%;top: 10px;height: auto;max-height: 600px;"
              :header-cell-style="{ background: '#5EA1F9' }">
              <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="deleteRowtable(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column label="因子编码" align="center">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.code'" :rules="dataRule.code">
                    <el-input v-model="scope.row.code" placeholder="因子编码" show-word-limit></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="因子名称" align="center" width="230">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.name'" :rules="dataRule.name">
                    <el-input v-model="scope.row.name" placeholder="因子名称"></el-input>
                    <div style="position: absolute;top: 0;right: 0px;">
                      <el-dropdown placement="bottom" trigger="click" @visible-change="changeDrop(scope.$index)"
                        @command="clickDropdown($event, scope.row, scope.$index)">
                        <el-button>插入下标</el-button>
                        <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
                          <el-dropdown-item command="₀">₀</el-dropdown-item>
                          <el-dropdown-item command="₁">₁</el-dropdown-item>
                          <el-dropdown-item command="₂">₂</el-dropdown-item>
                          <el-dropdown-item command="₃">₃</el-dropdown-item>
                          <el-dropdown-item command="₄">₄</el-dropdown-item>
                          <el-dropdown-item command="₅">₅</el-dropdown-item>
                          <el-dropdown-item command="₆">₆</el-dropdown-item>
                          <el-dropdown-item command="₇">₇</el-dropdown-item>
                          <el-dropdown-item command="₈">₈</el-dropdown-item>
                          <el-dropdown-item command="₉">₉</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="监测排序" align="center">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.sort'" :rules="dataRule.sort">
                    <el-input v-model="scope.row.sort" placeholder="因子单位"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="因子单位" align="center" width="230">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.unit'" :rules="dataRule.unit">
                    <el-input v-model="scope.row.unit" placeholder="因子单位"></el-input>
                    <div style="position: absolute;top: 0;right: 0px;">
                      <el-dropdown placement="bottom" trigger="click"
                        @command="clickDropdownunit($event, scope.row, scope.$index)">
                        <el-button>插入上标</el-button>
                        <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
                          <el-dropdown-item command="⁰">⁰</el-dropdown-item>
                          <el-dropdown-item command="¹">¹</el-dropdown-item>
                          <el-dropdown-item command="²">²</el-dropdown-item>
                          <el-dropdown-item command="³">³</el-dropdown-item>
                          <el-dropdown-item command="⁴">⁴</el-dropdown-item>
                          <el-dropdown-item command="⁵">⁵</el-dropdown-item>
                          <el-dropdown-item command="⁶">⁶</el-dropdown-item>
                          <el-dropdown-item command="⁷">⁷</el-dropdown-item>
                          <el-dropdown-item command="⁸">⁸</el-dropdown-item>
                          <el-dropdown-item command="⁹">⁹</el-dropdown-item>
                          <el-dropdown-item command="ⁿ">ⁿ</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="因子类型" align="center">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.type'" :rules="dataRule.type">
                    <el-select v-model="scope.row.type">
                      <el-option label="监测值" :value="0"></el-option>
                      <el-option label="计算值" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="报警模式" align="center">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.alarmType'" :rules="dataRule.alarmType">
                    <el-select v-model="scope.row.alarmType">
                      <el-option label="高报模式" :value="0"></el-option>
                      <el-option label="低报模式" :value="1"></el-option>
                      <el-option label="区间报警模式" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="一级预警值" align="center">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.firstAlarmValue'"
                    :rules="dataRule.firstAlarmValue">
                    <el-input v-model="scope.row.firstAlarmValue" show-word-limit placeholder="一级预警值"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="二级预警值" align="center">
                <template slot-scope="scope">
                  <el-form-item :prop="'deviceList.' + scope.$index + '.secondAlarmValue'"
                    :rules="dataRule.secondAlarmValue">
                    <el-input v-model="scope.row.secondAlarmValue" show-word-limit placeholder="二级预警值"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 10px;">
              <i class="el-icon-circle-plus-outline" style="font-size: 30px;cursor: pointer" @click="addRowtable"></i>
            </div>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footeruser">
        <el-button type="primary" @click="saveGet">确定</el-button>
        &nbsp;&nbsp;
        <el-button type="danger" @click="visible = false">取消</el-button>
      </span>
    </div>
  </el-dialog>

</template>

<script>
export default {
  name: 'batchAddition',
  data() {
    return {
      visible:false,
      fromId:'',
      dataForm: {
        formname: '',
        deviceList: [{
          code: '',
          name: '',
          sort: '',
          unit: '',
          type: 0,
          alarmType: 0,
          firstAlarmValue: '',
          secondAlarmValue: '',
        }],
      },
      //验证规则
      dataRule: {
        code: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        sort: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        unit: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        type: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        alarmType: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        firstAlarmValue: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        secondAlarmValue: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
      },
    }
  },
  created() {

  },
  methods: {
    init(val){
      this.visible = true
      console.log(val)
      this.fromId = val.id
      this.dataForm.formname = val.name
      this.dataForm.deviceList = val.templateDataList
    },
    clickDropdown(item, row, index) {
      row.name = row.name + item
    },
    clickDropdownunit(item, row, index) {
      row.unit = row.unit + item
    },
    deleteRowtable(row, index) {
      this.dataForm.deviceList.splice(index, 1);
    },
    addRowtable() {
      var item = {
        code: '',
        name: '',
        sort: '',
        unit: '',
        type: 0,
        alarmType: 0,
        firstAlarmValue: '',
        secondAlarmValue: '',
      }
      this.dataForm.deviceList.push(item)
    },

    saveGet() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl('ChannelTemplate/update'),
            method: 'post',
            data: this.$http.adornData({
              "id": this.fromId, 
              "name": this.dataForm.formname,//点位名称
              "templateDataList": this.dataForm.deviceList
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000
              })
            } else {
              this.$message.error(data.msg);
            }
          })
        }
      })
    }
  }
}
</script>

<style>
.boxuser .toplist {
  height: 50px;
  line-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #bbb;
}

.mod-config {
  position: relative;
}

.dialog-footeruser {
  display: flex;
  bottom: 0px;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  border-top: 2px solid #bbb;
  height: 60px;
}

.userMuban {
  margin-top: 10px;
  height: 226px;
}

.boxuser .userMuban .el-table td,
.boxuser .userMuban .el-table th.is-leaf {
  border-right: none !important
}

.boxuser .el-form-item {
  margin-bottom: 0
}

.boxuser .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: initial;
}

.boxuser .userMuban .el-table__body-wrapper {
  max-height: 540px;
  overflow-y: scroll;
  padding-bottom: 10px;
}

.editbatch .el-dialog {
  height: calc(100% - 100px);
}
.editbatch .el-dialog .el-dialog__body{
    height: calc(100% - 60px);
}
</style>


// WEBPACK FOOTER //
// src/pages/admincenter/batchAdd/edit-add-or-update.vue